import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Sidebar from './Sidebar';
import ProjectList from './ProjectList';
import ProjectRouter from './ProjectRouter';
import FoliosList from './FoliosList';
import FolioEditor from './FolioEditor';
import HorizonPage from './HorizonPage';
import OrgSettings from './OrgSettings';
import Inbox from './Inbox';
import DASAdmin from './DASAdmin';
import { OrgProvider } from '../context/OrgContext';
import './Dashboard.css';

function Dashboard({ user, onLogout, onUpdateUser }) {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const response = await axios.get('/projects');
      setProjects(response.data);
    } catch (error) {
      console.error('Failed to fetch projects:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateProject = async (projectData) => {
    try {
      const response = await axios.post('/projects', projectData);
      setProjects([...projects, response.data]);
      return response.data;
    } catch (error) {
      console.error('Failed to create project:', error);
      throw error;
    }
  };

  const handleUpdateProject = async (projectId, projectData) => {
    try {
      const response = await axios.put(`/projects/${projectId}`, projectData);
      setProjects(projects.map(p => p._id === projectId ? response.data : p));
      return response.data;
    } catch (error) {
      console.error('Failed to update project:', error);
      throw error;
    }
  };

  const handleDeleteProject = async (projectId) => {
    try {
      await axios.delete(`/projects/${projectId}`);
      setProjects(projects.filter(p => p._id !== projectId));
      navigate('/');
    } catch (error) {
      console.error('Failed to delete project:', error);
      throw error;
    }
  };

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <OrgProvider memberships={user.memberships || []}>
      <div className="dashboard">
        <Sidebar
          user={user}
          projects={projects}
          onLogout={onLogout}
          onCreateProject={handleCreateProject}
          onUpdateUser={onUpdateUser}
        />

        <div className="dashboard-content">
          <Routes>
            <Route
              path="/"
              element={
                <ProjectList
                  projects={projects}
                  onCreateProject={handleCreateProject}
                />
              }
            />
            <Route
              path="/org/settings"
              element={<OrgSettings user={user} />}
            />
            <Route
              path="/inbox"
              element={<Inbox user={user} />}
            />
            <Route
              path="/das-admin/*"
              element={<DASAdmin user={user} />}
            />
            <Route
              path="/project/:projectId/*"
              element={
                <ProjectRouter
                  user={user}
                  onUpdateProject={handleUpdateProject}
                  onDeleteProject={handleDeleteProject}
                />
              }
            />
            <Route
              path="/project/:projectId/folios"
              element={<FoliosList />}
            />
            <Route
              path="/project/:projectId/folio/:folioId"
              element={<FolioEditor />}
            />
            {/* WR-024: the Horizon, a constraint-scheduled timeline over the
                project's tasks. More specific than /project/:projectId/*. */}
            <Route
              path="/project/:projectId/horizon"
              element={<HorizonPage />}
            />
            <Route
              path="/project/:projectId/horizon/:horizonId"
              element={<HorizonPage />}
            />
          </Routes>
        </div>
      </div>
    </OrgProvider>
  );
}

export default Dashboard;
